var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileSearchingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.5C14.7239 12.5 12.5 14.7239 12.5 17.5C12.5 20.2761 14.7239 22.5 17.5 22.5C20.2761 22.5 22.5 20.2761 22.5 17.5C22.5 14.7239 20.2761 12.5 17.5 12.5ZM22.5 22.5029L22.084 22.0869L21.7578 21.7598L21.4062 22.0596C20.3525 22.9562 18.9859 23.5 17.5 23.5C15.9087 23.5 14.383 22.8674 13.2578 21.7422C12.1326 20.617 11.5 19.0913 11.5 17.5C11.5 15.9087 12.1326 14.383 13.2578 13.2578C14.3126 12.203 15.7193 11.5815 17.2021 11.5078L17.5 11.5C19.0913 11.5 20.617 12.1326 21.7422 13.2578C22.8674 14.383 23.5 15.9087 23.5 17.5C23.5 18.9859 22.9562 20.3525 22.0596 21.4062L21.7598 21.7578L22.0869 22.084L22.5029 22.5H23.293L27.793 27L27 27.793L22.5 23.293V22.5029Z",
    fill: "#0B4F9F",
    stroke: "#0B4F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSearchingIcon);
export default __webpack_public_path__ + "static/media/mobile-searching-icon.37ef2c074a1ba417cc916047da662b4b.svg";
export { ForwardRef as ReactComponent };